import type { VisitParameters } from './types';

export type YandexMetricOptions = {
  clickmap: boolean;
  trackLinks: boolean;
  accurateTrackBounce: boolean;
  webvisor: boolean;
  trackHash: boolean;
  userParams: YandexMetricUser;
};

export type YandexMetricUser = Record<string, unknown>;

export class YandexMetric {
  private script: HTMLScriptElement | null = null;
  private noScript: HTMLElement | null = null;
  private counterId: number = 0;
  // TODO нужно хранить user, так как init идет после получение account, а counterId еще не получен из dynamic-env
  // FIXME после import-meta-env можно будет не хранить в контексте
  private _user: YandexMetricUser = {};

  init(
    counterId?: string | number,
    options: YandexMetricOptions = {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true,
      trackHash: true,
      userParams: {},
    }
  ) {
    if (!counterId) return;

    this.counterId = Number(counterId);

    const yandexMetricOptions = {
      ...options,
      userParams: {
        ...options.userParams,
        ...this.user,
      },
    };

    this.script = document.createElement('script');
    this.script.innerText = `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
       m[i].l=1*new Date();
       for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
       k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
       (window, document, "script", "https://mc.webvisor.org/metrika/tag_ww.js", "ym");

       ym("${counterId}", "init", ${JSON.stringify(yandexMetricOptions)});`;

    this.noScript = document.createElement('noscript');
    this.noScript.innerText = `<noscript><div><img src="https://mc.yandex.ru/watch/${counterId}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>`;

    document.head.append(this.script);
    document.head.append(this.noScript);
  }

  get user() {
    return this._user;
  }

  set user(user: YandexMetricUser) {
    this._user = user;
  }

  reachGoal(event: string, params?: VisitParameters | VisitParameters[]) {
    if (!globalThis.ym) return;
    globalThis.ym(this.counterId, 'reachGoal', event, params);
  }

  reset() {
    this.user = {};

    this.remove();
    this.init();
  }

  remove() {
    if (this.script) {
      this.script.remove();
    }
    if (this.noScript) {
      this.noScript.remove();
    }
  }
}

export const yandexMetric = new YandexMetric();
